import { Record } from 'immutable'
import { NotificationContext, NotificationSourceType } from './enums'

export interface INotification {
  readonly contactId: string
  readonly context: NotificationContext
  readonly creatorId: string
  readonly dateCreated: number
  readonly dateUpdated: number
  readonly id: string
  readonly notificationText: string
  readonly seen: boolean
  readonly sourceId: string
  readonly type: NotificationSourceType
}

const NotificationRecord = Record({
  contactId: '',
  context: NotificationContext.Standard,
  creatorId: '',
  dateCreated: 0,
  dateUpdated: 0,
  id: '',
  notificationText: '',
  seen: false,
  sourceId: '',
  type: NotificationSourceType.Post,
})

export class Notification extends NotificationRecord implements INotification {
  public static fromJS(initialState?: Partial<any>) {
    if (!initialState) {
      return new Notification()
    }

    const { context, dateCreated, dateUpdated, type, ...rest } = initialState

    return new Notification({
      context:
        typeof context === 'number' ? mapContextNumber(context) : context,
      dateCreated:
        typeof dateCreated === 'string'
          ? Math.floor(new Date(dateCreated).getTime() / 1000)
          : dateCreated,
      dateUpdated:
        typeof dateUpdated === 'string'
          ? Math.floor(new Date(dateUpdated).getTime() / 1000)
          : dateUpdated,
      type: typeof type === 'number' ? mapTypeNumber(type) : type,
      ...rest,
    })
  }

  public readonly contactId: string
  public readonly context: NotificationContext
  public readonly creatorId: string
  public readonly dateCreated: number
  public readonly dateUpdated: number
  public readonly id: string
  public readonly notificationText: string
  public readonly seen: boolean
  public readonly sourceId: string
  public readonly type: NotificationSourceType

  constructor(props?: Partial<Notification>) {
    props ? super(props) : super()
  }
}

function mapContextNumber(value: number) {
  switch (value) {
    case 0:
      return NotificationContext.All

    case 2:
      return NotificationContext.Calendar

    default:
      return NotificationContext.Standard
  }
}

function mapTypeNumber(value: number) {
  switch (value) {
    case 1:
      return NotificationSourceType.Assignment

    case 2:
      return NotificationSourceType.Lead

    case 3:
      return NotificationSourceType.Comment

    case 4:
      return NotificationSourceType.Favorite

    case 5:
      return NotificationSourceType.Message

    case 6:
      return NotificationSourceType.DueDiligenceItem

    case 7:
      return NotificationSourceType.SiteSuggestion

    case 8:
      return NotificationSourceType.ChatMention

    default:
      return NotificationSourceType.Post
  }
}
